// extracted by mini-css-extract-plugin
export default {"cameraContainer":"Verification_cameraContainer__c7MA8"};